const url = "https://bytepad.silive.in/";

export default url;